'use strict';

export default class FormInput extends React.Component {

    constructor(props) {
        super(props);
        this.type = props.type || 'input';
        this.id = `FormInput_${this.type}_${_.uniqueId()}`;
        this.state = {}
    }

    componentDidMount() {
        const $this = $(`#${this.id}`);
        if (['input', 'textarea'].includes(this.type)) {
            $this.on('focus', function () {
                $this.closest(".inputbox").addClass("changed focuced")
            })
            $this.focusout(function () {
                $this.closest(".inputbox").removeClass("focuced")
                if ($this.val() === "") {
                    $this.closest(".inputbox").removeClass("changed")
                }
            })
            this.updateHeight();
        }
        this.initDatepicker();
    }

    componentDidUpdate(prevProps) {
        const {value, autoHeight} = this.props;
        if(autoHeight && prevProps.value !== value) {
            this.updateHeight();
        }
    }

    updateHeight() {
        const {autoHeight} = this.props;
        if(autoHeight) {
            const $this = $(`#${this.id}`);
            $this.css('height', 'auto');
            $this.css('height', $this[0].scrollHeight + 'px');
        }
    }

    handleChange(value) {
        const {onChange} = this.props;
        if(onChange) onChange(value);
        this.updateHeight();
    }

    prepareLabel(label) {
        const that = this;
        let resultStrings = [label.text];
        let result;

        if (label.replace) {

            // label.replace.forEach(replace => {
            //     const text = `<a href="${replace.href}" target="${replace.target}">${replace.text}</a>`
            //     result = result.replace(replace.text, text);
            // })
            // result = result.toString();

            label.replace.forEach(replace => {
                let newResult = [];
                resultStrings.forEach(part => {
                    const splitParts = part.split(replace.text);
                    newResult.push(splitParts[0]);
                    if (splitParts.length > 1) {
                        newResult.push(replace.text);
                        newResult.push(splitParts[1]);
                    }
                })
                resultStrings = newResult;
            })

            result = resultStrings.map((part, index) => {
                
                let partBr = part;
                
                if (typeof part === 'string') {
                    partBr = partBr.split("\n");
                    if (partBr.length > 1) partBr.splice(1, 0, <br/>);
                }

                const replace = label.replace.find(e => part === e.text)

                let key = 'part' + index;

                if (!replace)
                    return <React.Fragment key={key}>
                        {partBr.map((part_br, index2) => <React.Fragment key={'part' + index2}>{part_br}</React.Fragment>)}
                    </React.Fragment>

                let onClick = () => {}
                let disposeEvent = () => {}
                if (replace.modal) {
                    if (replace.checkOnSuccess) {
                        disposeEvent = listenEvent(`${replace.modal}SuccessEvent`, () => {
                            this.handleChange(true);
                        })
                    }
                    onClick = e => {
                        e.preventDefault();
                        $.fancybox.open({
                            src: `#${replace.modal}`,
                            afterClose: () => {
                                if (replace.checkOnSuccess) {
                                    disposeEvent()
                                }
                            },
                            touch: false
                        });
                    }
                }

                return <a key={key} href={replace.href || '#'} target={replace.target} onClick={onClick}>
                    {partBr.map((part_br, index2) => <React.Fragment key={'part' + index2}>{part_br}</React.Fragment>)}
                </a>;
            })
        } else {
            result = label.text.split("\n").map(e => e.trimStart()).filter(e => e).join('!!!<br/>!!!').split('!!!').map(e => e === '<br/>' ? <br/> : e);
            return result.map(e => <React.Fragment key={'part'+e}>{e}</React.Fragment>)
        }
        
        return result;
    }

    initDatepicker() {
        const {type} = this.props;
        const $this = $(`#${this.id}`);

        if(type !== 'date') return;

        let days = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
        let months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        let monthsShort = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        if(window.locale === 'ru') {
            days = ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"];
            months = ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"];
            monthsShort = ["Янв", "Фев", "Март", "Апр", "Май", "Июн", "Июл", "Авг", "Сент", "Окт", "Ноя", "Дек"];
        }

        $this.datepicker({
            autoHide: true,
            weekStart: 1,
            offset: 0,
            endDate: moment(),
            format: "dd.mm.yyyy",
            daysMin: days,
            months: months,
            monthsShort: monthsShort,
            pick: () => {
                const date = $this.datepicker('getDate', true);
                this.handleChange(date);
            }
        });
    }

    render() {
        const {className, label, value, error, readOnly = false, disabled = false, multiLine = false} = this.props;

        if (this.type === 'checkbox') {
            const Tag = label.tag || 'span';
            return <div className={clsx('checkbox', className, {error})}>
                <input type="checkbox" id={this.id} checked={value} disabled={disabled} onChange={() => this.handleChange(!value)}/>
                <label htmlFor={this.id}><span></span></label>
                <Tag>{this.prepareLabel(label)}</Tag>
            </div>
        }

        if (this.type === 'textarea') return <div className={clsx('inputbox', className, {changed: value, 'error-filed': error})}>
            <label>{label}</label>
            <textarea
                rows="1"
                id={this.id}
                style={multiLine ? {} : {height: '58px'}}
                value={value}
                onChange={e => this.handleChange(e.target.value)}
                readOnly={readOnly}
                disabled={disabled}
                autoComplete={'off'}
            />

            {!!error && <div className="error-message">
                {error}
            </div>}
        </div>

        return <div className={clsx('inputbox', className, {changed: value, 'error-filed': error})}>
            <label htmlFor={this.id}>{label}</label>
            {['input', 'date'].includes(this.type) && <input
                id={this.id}
                type="text"
                value={value}
                onChange={e => this.handleChange(e.target.value)}
                readOnly={readOnly}
                disabled={disabled}
                autoComplete={'off'}
            />}

            {!!error && <div className="error-message">
                {error}
            </div>}
        </div>
    }
}
